// extracted by mini-css-extract-plugin
export var base = "_52-0";
export var updateBanner = "_52-1";